import { useDiagnosticsStore } from '@/store/useDiagnosticsStore';

export function RecordingControl() {
  const { isRecording, recordingStartedAt, startRecording, stopRecording } = useDiagnosticsStore();

  return (
    <div className={`rounded-lg shadow p-4 flex items-center justify-between ${
      isRecording
        ? 'bg-red-50 dark:bg-red-900 border-2 border-red-200 dark:border-red-700'
        : 'bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700'
    }`}>
      <div className="flex items-center gap-3">
        <button
          onClick={() => isRecording ? stopRecording() : startRecording()}
          className={`px-4 py-2 rounded-lg font-medium transition-all ${
            isRecording
              ? 'bg-red-600 hover:bg-red-700 text-white shadow-lg'
              : 'bg-green-600 hover:bg-green-700 text-white'
          }`}
        >
          {isRecording ? '⏹ Stop Recording Session' : '⏺ Start Recording Session'}
        </button>
        {recordingStartedAt && (
          <div>
            <p className="text-sm font-medium text-gray-900 dark:text-white">
              Session Active
            </p>
            <p className="text-xs text-gray-600 dark:text-gray-400">
              Started: {recordingStartedAt.toLocaleTimeString()}
            </p>
          </div>
        )}
      </div>
      {isRecording && (
        <div className="flex items-center gap-2 text-red-600 dark:text-red-400">
          <span className="animate-pulse">●</span>
          <span className="text-sm font-medium">Recording</span>
        </div>
      )}
    </div>
  );
}
